module.exports = __webpack_public_path__ + "static/media/29BDOS3.5c698ae2.jpg";